import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyLocation as MyLocationIcon } from '@mui/icons-material';

import { NavigateLinks } from '@/components';
import {
  INSTITUTIONAL_WEB_PAGE_NAME,
  institutionalWebPageBreadcrumbs,
} from './config';

const CARD_CLASS =
  'w-[200px] p-[20px] aspect-[4/3] flex flex-col justify-center items-center gap-3 bg-white rounded-[5px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-transform duration-[0.25s] cursor-pointer overflow-hidden hover:scale-105';

const CARD_LABEL_CLASS =
  'w-full shrink-0 text-base text-center overflow-hidden text-ellipsis whitespace-nowrap';

export const InstitutionalWeb = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => institutionalWebPageBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <section className='flex flex-col w-full h-full'>
      <NavigateLinks
        actualPage={INSTITUTIONAL_WEB_PAGE_NAME}
        breadcrumbs={breadcrumbs}
      />
      <ul className='h-full w-full grid grid-cols-[repeat(auto-fit,200px)] content-center justify-center gap-[50px] mx-auto'>
        <li
          className={CARD_CLASS}
          onClick={() => navigate('/institutional-web/live-tracking')}
        >
          <MyLocationIcon sx={{ fontSize: 56 }} />
          <p className={CARD_LABEL_CLASS}>Seguimiento en vivo</p>
        </li>
      </ul>
    </section>
  );
};

export default InstitutionalWeb;
